import { TaskState } from '../enums/task-state.enum';
import { TaskType } from '../enums/task-type.enum';
import { SubjectType } from '../enums/subject-type.enum';
import { WorkflowArea } from '../enums/workflow-area.enum';

export interface TaskMetaInformationTableValue {
    id: string;
    projectId: string;
    sectionName: string;
    sectionId: string;
    description: string;
    assignedTo: string | null;
    assigneeDeleted: boolean;
    dueDate: Date;
    taskState: TaskState;
    area: WorkflowArea;
    taskType: TaskType;
    /** Missing on person tasks. */
    companyName?: string;
    /** REV-22155 — missing = COMPANY. */
    subjectType?: SubjectType;
    personName?: string;
    latestComment: string | null;
}
